const IconContact = ({ className }) => {
    return (
        <svg
            width='38'
            height='38'
            viewBox='0 0 38 38'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                d='M26.9168 28.5C26.9168 27.6602 26.5832 26.8547 25.9893 26.2608C25.3955 25.667 24.59 25.3333 23.7502 25.3333H14.2502C13.4103 25.3333 12.6049 25.667 12.011 26.2608C11.4171 26.8547 11.0835 27.6602 11.0835 28.5'
                strokeWidth='2.11111'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M30.0833 6.33334H7.91667C6.16777 6.33334 4.75 7.75111 4.75 9.50001V31.6667C4.75 33.4156 6.16777 34.8333 7.91667 34.8333H30.0833C31.8322 34.8333 33.25 33.4156 33.25 31.6667V9.50001C33.25 7.75111 31.8322 6.33334 30.0833 6.33334Z'
                strokeWidth='2.11111'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M18.9997 19C20.7486 19 22.1663 17.5822 22.1663 15.8333C22.1663 14.0844 20.7486 12.6667 18.9997 12.6667C17.2508 12.6667 15.833 14.0844 15.833 15.8333C15.833 17.5822 17.2508 19 18.9997 19Z'
                strokeWidth='2.11111'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path d='M12.667 3.16666V6.33332' strokeWidth='2.11111' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M25.3335 3.16666V6.33332' strokeWidth='2.11111' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
};

export default IconContact;
